export default [
  {
    path: 'supplier',
    children: [
      {
        path: '',
        name: 'purchase list supplier',
        component: () => import('@/views/app/purchase/purchase-supplier/list/page-list.vue'),
        meta: { title: 'Daftar Pembelian Supplier' },
      },
      {
        path: ':id',
        name: 'purchase detail supplier',
        component: () => import('@/views/app/purchase/purchase-supplier/detail/page-detail.vue'),
        meta: { title: 'Detail Pembelian Supplier' },
      },
      {
        path: ':id/edit',
        name: 'purchase edit supplier',
        component: () => import('@/views/app/purchase/purchase-supplier/edit/page-edit.vue'),
        meta: { title: 'Edit Pembelian Supplier' },
      },
    ],
  },
  {
    path: 'cabang',
    children: [
      {
        path: '',
        name: 'purchase list branch',
        component: () => import('@/views/app/purchase/purchase-branch/list/page-list.vue'),
        meta: { title: 'Daftar Pembelian Cabang' },
      },
      {
        path: ':id',
        name: 'purchase detail branch',
        component: () => import('@/views/app/purchase/purchase-branch/detail/page-detail.vue'),
        meta: { title: 'Detail Pembelian Cabang' },
      },
    ],
  },
]
